export const Signin = () => {
  return `/signin`
}
export const Signup = () => {
  return `/signup`
}
export const Google = () => {
  return `/google?redirect_url=${window.location.host}`
}
export const ProviderCheck = () => {
  return `/validation`
}
export const LoadMenu = () => {
  return `/menus`
}
